import styled from 'styled-components'

import { BREAK_POINT_MD } from '@CSSVars/variables'
import { PRIMARY_DARK_COLOR, FEATURE_BANNER_COLOR } from '@CSSVars/colors'


export const _IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  div {
    display: flex;
    flex-direction: row;
    margin-right: 24px;
  }
  svg {
    margin-right: 6px;
  }
  position: absolute;
  bottom: 8px;
  left: 0px;
`

export const _Price = styled.div`
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: right;
  color: ${PRIMARY_DARK_COLOR};

`

export const _ListingDetailContainer = styled.div`
  display: none;
  flex-direction: column;
  justify-content: start;
  padding: 0px 12px 0px 12px;
  width: 100%;
  overflow: hidden;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: flex;
  }
`

export const _UnitInformationContainer = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 2px;
  max-width: calc(100% - 74px);
  overflow: hidden; 
  white-space: nowrap; 
  text-overflow: ellipsis;
`

export const _PriceContainer = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: start;
   align-items: start;

`

export const _MaintFee = styled.div`
    font-size: 12px;
    font-weight: 500;
    line-height: 22px;
    text-align: right;
    white-space: nowrap;
    margin-bottom: 2px;
`

export const _Tag = styled.div`
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 500;
    line-height: 14.63px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    padding: 3px 8px;
    color: ${FEATURE_BANNER_COLOR};
    background: #07364B1A;
    border-radius: 4px;
    width: fit-content;
    position: absolute;
    top:0;
    right: 12px;
`
